import axios from 'axios';
import type { QueryParamsInterface } from '@/types/Shared';
import { baseUrl, HttpMethods } from '../../base';

const basePath = `${baseUrl.SHERPA}/workspaces`;

export const getWorkspaces = async (params?: QueryParamsInterface): Promise<IGetWorkspacesServiceRes> => {
  const res = await axios.request<IGetWorkspacesServiceRes>({
    method: HttpMethods.GET,
    url: basePath,
    params,
  });
  return res.data;
};

export const putWorkspace = async ({ workspaceId, data }: IPutWorkspaceService) => {
  const res = await axios.request({
    method: HttpMethods.PUT,
    url: `${basePath}/${workspaceId}`,
    data,
  });
  return res.data;
};

export const postWorkspace = async ({ data }: IPostWorkspaceService) => {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: basePath,
    data,
  });
  return res.data;
};

export const patchArchiveWorkspace = async ({ id }: IPatchArchiveWorkspaceService) => {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${basePath}/${id}/archive`,
  });
  return res.data;
};

export const patchUnArchiveWorkspace = async ({ id }: IPatchUnArchiveWorkspaceService) => {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${basePath}/${id}/unarchive`,
  });
  return res.data;
};
